import { IPinpadService } from "modules/payment/application/interfaces/IPinpadService";
import { TransactionType } from "modules/payment/domain/models/TransactionType";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";
import { resolvePinpadService } from "domains/order/services/resolvePinpadService";

export const UsePinpad = () => {

  const doPinpadPayment = async (value: number, type: TransactionType, kiosk?: Kiosk, orderId?: string, operationId?: string) => {
    if(!kiosk) {
      throw new Error("Kiosk não informado");
    }
    const paymentService: IPinpadService = resolvePinpadService(kiosk);
    const result = await paymentService.payAsync(value, type, kiosk as Kiosk, orderId, operationId);
    return result
  };

  return {
    doPinpadPayment,
  };
};
